import state from '../store/modules/admin';

const getEnvVar = key => {
  const variable = state.state.adminVariables.find(
    variable => variable.key === key,
  );
  return variable ? variable.value : '';
};

export { getEnvVar };
